import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import flattenedMediaModel from 'models/flattenedMediaModel';
import cx from 'classnames';

import { Video, Image } from 'components/base';

class EntranceOption extends Component {
  state = {
    currentVideo: this.props.entranceOption1Video,
    hoverIsActive: false
  };

  handleMouseEnter = video => {
    this.setState({ hoverIsActive: true, currentVideo: video });
  };

  handleMouseLeave = () => {
    this.setState({ hoverIsActive: false });
  };

  render() {
    const {
      entranceOption1Video,
      entranceOption2Video,
      entranceOption3Video
    } = this.props;

    return (
      <div className="EntranceOption absolute w100 bg-color-black z0 flex items-end justify-center">
        <div className="w100 vh100 z0">
          <Video
            loop={true}
            autoPlay={true}
            className={cx('fixed vh100 w100 fit-cover transition opacity-0', {
              'EntranceOption__video--active':
                entranceOption1Video.url === this.state.currentVideo.url
            })}
            src={entranceOption1Video.url}
          />
          <Video
            loop={true}
            autoPlay={true}
            className={cx('fixed vh100 w100 fit-cover transition opacity-0', {
              'EntranceOption__video--active':
                entranceOption2Video.url === this.state.currentVideo.url
            })}
            src={entranceOption2Video.url}
          />
          <Video
            loop={true}
            autoPlay={true}
            className={cx('fixed vh100 w100 fit-cover transition opacity-0', {
              'EntranceOption__video--active':
                entranceOption3Video.url === this.state.currentVideo.url
            })}
            src={entranceOption3Video.url}
          />
        </div>
        <div className="EntranceOption__container absolute w100 z1 flex flex-col items-center justify-center">
          <div
            className="EntranceOption__button-container"
            onMouseLeave={this.handleMouseLeave}
            onMouseEnter={() => this.handleMouseEnter(entranceOption1Video)}
          >
            <NavLink
              className={cx(
                'EntranceOption__button uppercase text-center color-white transition flex flex-col',
                { 'EntranceOption__hover--active': this.state.hoverIsActive }
              )}
              exact
              to="/quiz"
            >
              Match With a Laureate
            </NavLink>
          </div>
          <div
            className="EntranceOption__button-container"
            onMouseLeave={this.handleMouseLeave}
            onMouseEnter={() => this.handleMouseEnter(entranceOption2Video)}
          >
            <NavLink
              onClick={this.props.removeAllCategories}
              className={cx(
                'EntranceOption__button uppercase text-center color-white transition flex flex-col',
                { 'EntranceOption__hover--active': this.state.hoverIsActive }
              )}
              exact
              to="/stories"
            >
              Browse Their Stories
            </NavLink>
          </div>
          <div
            className="EntranceOption__button-container"
            onMouseLeave={this.handleMouseLeave}
            onMouseEnter={() => this.handleMouseEnter(entranceOption3Video)}
          >
            <NavLink
              className={cx(
                'EntranceOption__button uppercase text-center color-white transition flex flex-col',
                { 'EntranceOption__hover--active': this.state.hoverIsActive }
              )}
              exact
              to="/explore"
            >
              Explore Their Connections
            </NavLink>
          </div>
          <div className="absolute b0 mxauto mb2 flex flex-row justify-center items-center">
            <p className="msft-logo-text color-white">Powered by</p>
            <Image
              alt="Microsoft logo"
              className="msft-logo ml_5"
              src={`${
                process.env.PUBLIC_URL
              }/assets/images/MSFT-logo-light.png`}
            />
          </div>
        </div>
      </div>
    );
  }
}

EntranceOption.propTypes = {
  entranceOption1Video: flattenedMediaModel.propTypes,
  entranceOption2Video: flattenedMediaModel.propTypes,
  entranceOption3Video: flattenedMediaModel.propTypes
};

EntranceOption.defaultProps = {
  entranceOption1Video: flattenedMediaModel.default,
  entranceOption2Video: flattenedMediaModel.default,
  entranceOption3Video: flattenedMediaModel.default
};

export default EntranceOption;
